import { Box, SvgIcon, Typography } from '@mui/material';

import { FEATURES_FLAG_KEYS } from '@/features/featuresFlag/apis/featureFlag.keys';
import { useFeaturesFlagState } from '@/features/featuresFlag/hooks';
import { SvgIconType } from '@/features/shared/types';

import { stylesBoxChoice, stylesBoxChoiceText } from './BoxChoice.styles';

export type BoxChoiceProps = {
  label: string;
  icon: SvgIconType;
  handleRedirect: () => void;
};
export const BoxChoice: React.FunctionComponent<BoxChoiceProps> = ({ icon, label, handleRedirect }) => {
  const { featuresFlag } = useFeaturesFlagState();
  const isSherpass = featuresFlag.get(FEATURES_FLAG_KEYS.SHERPASS);
  return (
    <Box data-testid='box-choice' onClick={handleRedirect} sx={stylesBoxChoice}>
      <SvgIcon
        data-testid='svg-icon'
        component={icon}
        color='info'
        sx={{
          fontSize: 'bodyXLBold.fontSize',
          mt: 0.25,
          width: '4rem',
          height: '4rem',
          color: isSherpass ? '#104447' : undefined,
        }}
      />
      <Typography sx={stylesBoxChoiceText}>{label}</Typography>
    </Box>
  );
};
